export const AUTH_TOKEN_KEY = 'auth:token'
export const CREATE_ACCOUNT_KEY = '@CreateAccount'
